import LaunchIcon from '@mui/icons-material/Launch';
import axios from 'axios';
import BoxWrapper from 'blocks/BoxWrapper';
import Button from 'blocks/Button';
import Row from 'blocks/Row';
import { PageTitle } from 'blocks/Text';
import EmptyBox from 'components/EmptyBox';
import Table from 'components/Table';
import ModalChangePassKids from 'components/modals/ModalChangePassKids';
import { KidsProps } from 'components/modals/ModalChangePassKids/modalChangePassKids.interface';
import ModalKidsDetail from 'components/modals/ModalKidsDetail';
import WithSidebar from 'layouts/WithSidebar';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import urls from 'utils/urls';
import * as S from './MyKides.styles';

const MyKides = () => {
  const { t } = useTranslation();
  const [kids, setkids] = useState<any[]>([]);
  const modalChangePassKids = useRef<any>();
  const modalKidsDetail = useRef<any>();

  useEffect(() => {
    getKids();
  }, []);

  const getKids = async () => {
    const res = await axios.get(urls.kids);
    console.log(res.data.response);
    setkids(res.data.response);
  };

  const showModalChangePassKids = (kid: KidsProps): void => {
    modalChangePassKids.current.openModal(kid);
  };

  const showModalKidsDetail = (kid: KidsProps): void => {
    modalKidsDetail.current.openModal(kid);
  };

  return (
    <WithSidebar>
      <S.Wrapper>
        <BoxWrapper>
          <S.PageTitle as={Row} justify="space-between" align="center">
            <PageTitle>{t('pages.kids.title')}</PageTitle>
          </S.PageTitle>
        </BoxWrapper>
        {kids.length ? (
          <>
            <S.ParentTable>
              <Table
                name="kids"
                head={[
                  { text: t('pages.kids.sections.tables.kids.headers.kidsName') },
                  { text: t('pages.kids.sections.tables.kids.headers.idNumber') },
                  { text: t('') },
                ]}
                rows={kids.map((kid) => [
                  { content: kid.enFname + ' ' + kid.enLname },
                  { content: kid.idNumber },
                  {
                    content: (
                      <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                        <Button styleType="text-button" onClick={() => showModalChangePassKids(kid)} size={'small'}>
                          {t('pages.kids.sections.tables.kids.changePassword.title')}
                        </Button>
                        <Button
                          color="text-button"
                          iconStart={<LaunchIcon />}
                          styleType="text-button"
                          onClick={() => showModalKidsDetail(kid)}
                          size={'large'}
                        />
                      </div>
                    ),
                    className: 'action-table',
                  },
                ])}
              />
            </S.ParentTable>
          </>
        ) : (
          <EmptyBox boxed title={t('pages.kids.sections.tables.kids.emptyText')} />
        )}
      </S.Wrapper>
      <ModalKidsDetail ref={modalKidsDetail} />
      <ModalChangePassKids ref={modalChangePassKids} />
    </WithSidebar>
  );
};

export default MyKides;
